import { Component, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ThemeType } from 'src/app/shared/models';
import { ThemeService } from 'src/app/shared/services';

@Component({
    selector: 'app-search-awb',
    templateUrl: './search-awb.component.html',
    styleUrls: ['./search-awb.component.scss'],
    standalone: false,
})
export class SearchAwbComponent implements OnDestroy {
    private unsubscribe$ = new Subject<void>();
    public allianceImages: string[];
    public ThemeType = ThemeType;
    public currentTheme: ThemeType;
    public bannerMessage: string;
    public bannerTitle: string;

    constructor(private themeService: ThemeService) {
        this.allianceImages = [
            'assets/alliance/img/img-warehouse-01.webp',
            'assets/alliance/img/img-warehouse-02.webp',
            'assets/alliance/img/img-warehouse-03.webp',
        ];

        this.subscribeTheme();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    subscribeTheme(): void {
        this.themeService
            .getTheme()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((theme) => (this.currentTheme = theme));
    }
}
